<div id="kt_header_mobile" class="header-mobile align-items-center" style="background-color:#ffffff">
  <a href="./client/forms" style="display:none">
    <img alt="Logo" src="assets/media/logo/dhslogocolor350.png" />
  </a>
</div>
<div id="kt_header" class="header">
  <div class="container-fluid d-flex align-items-stretch justify-content-between">
    <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
      <div class="header-logo" >
        <a href="./" style="display:none">
          <img alt="Logo" src="assets/media/logo/dhslogocolor350.png" />
        </a>
      </div>
    </div>
  </div>
</div>
<div style="height:100%; background-color:white">
  <div class="content bg-white  d-flex flex-column flex-column-fluid" style="padding-top:6%; padding-bottom:6%" id="kt_content">
    <div class="d-flex flex-column-fluid">
      <div class="container" style="text-align:center">
        <!--begin::Icon-->
        <div class="d-flex flex-center position-relative mb-25">
          <span class="svg svg-fill-danger opacity-4 position-absolute">
            <svg width="175" height="200">
              <polyline points="87,0 174,50 174,150 87,200 0,150 0,50 87,0"></polyline>
            </svg>
          </span>
          <span class="svg-icon svg-icon-danger svg-icon-5x">
            <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/General/Shield-protected.svg-->
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <path d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z" fill="#000000" opacity="0.3" />
                <path d="M14.5,11 C15.0522847,11 15.5,11.4477153 15.5,12 L15.5,15 C15.5,15.5522847 15.0522847,16 14.5,16 L9.5,16 C8.94771525,16 8.5,15.5522847 8.5,15 L8.5,12 C8.5,11.4477153 8.94771525,11 9.5,11 L9.5,10.5 C9.5,9.11928813 10.6192881,8 12,8 C13.3807119,8 14.5,9.11928813 14.5,10.5 L14.5,11 Z M12,9 C11.1715729,9 10.5,9.67157288 10.5,10.5 L10.5,11 L13.5,11 L13.5,10.5 C13.5,9.67157288 12.8284271,9 12,9 Z" fill="#000000" />
              </g>
            </svg>
            <!--end::Svg Icon-->
          </span>

        </div>
        <!--end::Icon-->
        <div *ngIf="isSpanishlanguage() != true">
          <div class="row" *ngIf="counter > 0">
            <div class="card card-custom" style="box-shadow:none">
              <div class="pb-5 pb-lg-15">
                <h3 class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">Verify your State ID</h3>
                <div class="text-secondary font-weight-bold font-size-h4">
                  Enter the State ID of any member of your case. Your State ID can be found on your Medicaid card or on your Medicaid review form.
                </div>
              </div>
              <div class="form-group fv-plugins-icon-container mt-2" [formGroup]="authenticationInfo">
                <input class="form-control form-control-solid h-auto py-4 px-6 border-0 rounded-lg font-size-h6-xxl text-center font-size-lg"
                       type="text"
                       name="stateID"
                       placeholder="State ID"
                       maxlength="8"
                       formControlName="stateID">
              </div>
              <button type="button" class="mt-2 mb-2 btn btn-primary" (click)="verifyData()"> Verify </button>
              <div *ngIf="counter < 3" class="text-danger text-left mt-2 mb-2">
                *The State ID entered does not match any from the case, {{counter}} attempts remaining.
              </div>
            </div>
          </div>
          <div class="row" *ngIf="counter == 0">
            <div class="card card-custom" style="box-shadow:none">
              <div class="pb-5 pb-lg-15">
                <h3 class="font-weight-bolder text-danger font-size-h2 font-size-h1-lg">Authentication failed</h3>
                <div class="text-secondary font-weight-bold font-size-h4">
                  You have tried to enter a State ID 3 times and none matched any from your case, your account has been locked. You may try again in 3 minutes.<br />
                  If you do not know your State ID, call 1-855-889-7985.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isSpanishlanguage() == true">
          <div class="row" *ngIf="counter > 0">
            <div class="card card-custom" style="box-shadow:none">
              <div class="pb-5 pb-lg-15">
                <h3 class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">
                  Verifique su ident. del estado
                </h3>
                <div class="text-secondary font-weight-bold font-size-h4">
                  Introduzca la ident. del estado de cualquier miembro de su caso. Puede encontrar su ident. del estado en su tarjeta de Medicaid o en su formulario de revisión de Medicaid.
                </div>
              </div>
              <div class="form-group fv-plugins-icon-container mt-2" [formGroup]="authenticationInfo">
                <input class="form-control form-control-solid h-auto py-4 px-6 border-0 rounded-lg font-size-h6-xxl text-center font-size-lg"
                       type="text"
                       name="stateID"
                       placeholder="Ident. del estado"
                       maxlength="8"
                       formControlName="stateID">
              </div>
              <button type="button" class="mt-2 mb-2 btn btn-primary" (click)="verifyData()">Verificar</button>
              <div *ngIf="counter < 3" class="text-danger text-left mt-2 mb-2">
                * La identificación del estado ingresada no coincide con ninguna del caso, quedan {{counter}} intentos.
              </div>
            </div>
          </div>
          <div class="row" *ngIf="counter == 0">
            <div class="card card-custom" style="box-shadow:none">
              <div class="pb-5 pb-lg-15">
                <h3 class="font-weight-bolder text-danger font-size-h2 font-size-h1-lg">Autenticación fallida</h3>
                <div class="text-secondary font-weight-bold font-size-h4">
                  Ha intentado ingresar una identificación estatal 3 veces y ninguna coincide con ninguna de su caso, su cuenta ha sido bloqueada. Puede volver a intentarlo en 3 minutos.<br />
                  Si no conoce su identificación estatal, llame al 1-855-889-7985.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
  <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
    <div class="text-dark order-2 order-md-1">
      <span class="font-weight-bold mr-2">{{ currentYear }}</span>
      <a href="https://dhs.iowa.gov/" target="_blank" class="text-dark-75 text-hover-primary">IOWA Department of Human Service</a>
    </div>
    <div class="nav nav-dark">
    </div>
  </div>
</div>





